import { render, staticRenderFns } from "./OrderItemViewer.vue?vue&type=template&id=582e09d5&"
import script from "./OrderItemViewer.vue?vue&type=script&lang=js&"
export * from "./OrderItemViewer.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemViewer.vue?vue&type=style&index=0&id=582e09d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports